import Abstract from '../../framework/Abstract';
import Slider from '../../framework/Slider';

import { getParentElementByClass } from '../../framework/helpers';

import './search-modules.scss';

class SearchModules extends Abstract {
	init() {
		this.state = {
			viewport: null,
		};

		this.subscribe(this.onStoreUpdate);

		this.onStoreUpdate();
		setTimeout(this.onStoreUpdate.bind(null, true), 40);
	}

	setupSlider() {
		const secondaries = this.root.querySelector('.search-modules__secondaries');
		const secondaryModules = secondaries.querySelectorAll('.search-module:not(.is-primary)');
		const searchContent = getParentElementByClass(this.root, 'search-page__content');
		let replacedElements = false;

		// Move all secondary modules from secondaries container into the swiper wrapper
		if (secondaryModules && secondaryModules.length) {
			Array.from(secondaryModules).forEach((secondary) => {
				secondaries.parentNode.insertBefore(secondary, secondaries);
			});

			replacedElements = true;
		}

		// Removing inline min-height styling on the search content
		if (searchContent) {
			searchContent.style.minHeight = '';
		}

		// Setup slider functionality
		this.slider = new Slider(this.root.querySelector('.swiper-container'), {
			speed: 500,
			slidesPerView: 'auto',
			centeredSlides: true,
		});

		if (replacedElements) {
			this.setupObjectFit();
		}
	}

	setupDesktopView() {
		if (this.slider) {
			this.slider.destroy();
			this.slider = null;
		}

		const secondaries = this.root.querySelector('.search-modules__secondaries');
		const secondaryModules = this.root.querySelectorAll('.swiper-wrapper > .search-module:not(.is-primary)');
		const searchContent = getParentElementByClass(this.root, 'search-page__content');
		let replacedElements = false;

		// Move all secondary modules from swiper wrapper into the secondaries container
		if (secondaryModules && secondaryModules.length) {
			Array.from(secondaryModules).forEach((secondary) => {
				secondaries.appendChild(secondary);
			});

			replacedElements = true;
		}

		const secondariesHeight = secondaries.clientHeight;

		// Setting inline min-height on the search container so the absolute placed secondary modules won't
		// overlap the footer on the page, in case of a search results page without many results.
		if (searchContent) {
			searchContent.style.minHeight = secondariesHeight ? `${secondariesHeight}px` : '';
		}

		if (replacedElements) {
			this.setupObjectFit();
		}
	}

	onStoreUpdate = (forceCheck = false) => {
		const store = this.getState('global');
		const { viewport } = store;
		const { viewport: prevViewport } = this.state;

		if (!viewport) return;

		const isDesktop = viewport === 'lg' || viewport === 'xl' || viewport === 'xxl';

		if ((viewport !== prevViewport || forceCheck) && isDesktop) {
			this.setupDesktopView();
		} else if (viewport !== prevViewport && !isDesktop && !this.slider) {
			this.setupSlider(viewport);
		}

		this.state.viewport = viewport;
	}
}

export default SearchModules;
